import React from 'react'
import { ScaleLinear } from 'd3-scale'
import { config } from '../'
type yTicksDataType = { text?: number[]; lines?: number[] }
export const YTicks = ({
  data,
  x,
  y,
  maxwidth
}: {
  data: yTicksDataType
  x: ScaleLinear<number, number>
  y: ScaleLinear<number, number>
  maxwidth?: number
}) => {
  if (!data) return null
  return (
    <>
      {data.lines &&
        data.lines.map((t, i) => {
          return (
            <line
              key={i}
              y1={y.range()[0] - y(t)}
              y2={y.range()[0] - y(t)}
              x1={x.range()[0]}
              x2={maxwidth || x.range()[1]}
              className={'tickline ' + (t === 0 ? 'base' : '')}
            />
          )
        })}
      {data.text &&
        data.text.map((t, i) => {
          return (
            <text
              key={i}
              x={x.range()[0] + 3}
              y={y.range()[0] - y(t) + config.textOffsetY}
              className='ticktext'
            >
              {t}
            </text>
          )
        })}
    </>
  )
}
